import { GetAggregationView } from './GetAggregationView';
import { GetExportDetails } from './GetExportDetails';
import { GetIreRiskRecord } from './GetIreRiskRecord';
import { GetRiskDashboardStatistics } from './GetRiskDashboardStatistics';
import { GetRiskRecord } from './GetRiskRecord';
import { GetRiskRecordsCount } from './GetRiskRecordsCount';
import { GetRiskRecordTimeline } from './GetRiskRecordTimeline';
import { GetRiskTrendReport } from './GetRiskTrendReport';
import { ListRedRiskCodes } from './ListRedRiskCodes';
import { ListRiskCodes } from './ListRiskCodes';
import { ListRiskRecords } from './ListRiskRecords';
import { ListTimelineEventTypes } from './ListTimelineEventTypes';
import { ListTrustedValueHistory } from './ListTrustedValueHistory';
import { ListViews } from './ListViews';

/**
 * queries
 *
 * @type {{GetAggregationView: ((function({}=): Promise<*>)|*), GetExportDetails: ((function({}=): Promise<*>)|*), GetIreRiskRecord: ((function({}=): Promise<*>)|*), GetRiskDashboardStatistics: ((function({}=): Promise<*>)|*), GetRiskRecord: ((function({}=): Promise<*>)|*), GetRiskRecordsCount: ((function({}=): Promise<*>)|*), GetRiskRecordTimeline: ((function({}=): Promise<{timelines: {[p: string]: *}}>)|*), GetRiskTrendReport: ((function({}=): Promise<*>)|*), ListRedRiskCodes: ((function({}=): Promise<*>)|*), ListRiskCodes: ((function({}=): Promise<*>)|*), ListRiskRecords: ((function({}=): Promise<*>)|*), ListTimelineEventTypes: ((function({}=): Promise<*>)|*), ListTrustedValueHistory: ((function({}=): Promise<*>)|*), ListViews: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  GetAggregationView,
  GetExportDetails,
  GetIreRiskRecord,
  GetRiskDashboardStatistics,
  GetRiskRecord,
  GetRiskRecordsCount,
  GetRiskRecordTimeline,
  GetRiskTrendReport,
  ListRedRiskCodes,
  ListRiskCodes,
  ListRiskRecords,
  ListTimelineEventTypes,
  ListTrustedValueHistory,
  ListViews,
};
